import React, {useEffect, useState} from 'react';
import ReactGA from "react-ga4";
import {useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Activity, Hostage, User} from '../types';
import ActivityCard from './ActivityCard';
import { fetchHostages } from '../Hostage/hostageFetchUtils';
import { Button } from '@mui/material';


const ActivityPage = () => {
  const {t} = useTranslation();
  const {id} = useParams();
  const [hostages, setHostages] = useState<Hostage[]>([]);
  const [activity, setActivity] = useState<Activity | null>(null);

  
  function getEventOwner(activity: Activity): Hostage {
    return hostages.filter(x => activity.hostages.includes(x.id))[0];
  }

  function getHostageByEvent(activity: Activity): Hostage {
    return activity.isPublic ? hostages[0] : getEventOwner(activity);
  }

  useEffect(() => {
    fetchAllHostages();
    fetchActivity();
  }, [id]);

  const fetchAllHostages = async () => {
    try {     
      const res = await fetchHostages();
      if (res && res.items.length > 0) {
        setHostages(res.items);
      } 

    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const fetchActivity = async () => {
    try {
      const response = await fetch(`/api/activity/${id}`, {
        method: "GET",
        credentials: "include",
      });
      const res = (await response.json()) as Activity;
      setActivity(res);

    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const handleBackToList = () => {
    window.location.href = '/home';
  };
  
  return (
    <div style={{margin: '70px 45px'}} className="hostage-card-container">
      <div className="sticky-header">
        <Button
          onClick={handleBackToList}
          className='back-to-list-btn'
        >
          {t('hostageCard.backToList')}
        </Button>
      </div>
        {activity && <ActivityCard
          key={id}
          activity={activity}
          hostage={getHostageByEvent(activity)}
          eventOwner={getEventOwner(activity)}
          showLink={!activity.isPublic}
          numOfRegisteredUsers={activity.registeredUsersCount}
          showReadMore={false}
          onRefresh={fetchActivity}
          onJoin={fetchActivity}
          onUndoJoin={fetchActivity}
        />}
    </div>   
  );
};


export default ActivityPage;

